import { Bar } from '@ant-design/plots'
import { Card } from 'antd'
import getDashboardContactOverview from 'api/dashboard/getDashboardContactOverview'
import React, { useEffect, useState } from 'react'
import toTileCase from 'utils/toTitleCase'

import style from './style.module.scss'

interface ContactOverviewStatistic {
	title: string
	value: number
	key: string
}
interface PropType {
	clientId?: string
}

const ContactOverviewCard: React.FC<PropType> = ({ clientId }) => {
	const [stats, setStats] = useState<ContactOverviewStatistic[]>([])
	const [loading, setLoading] = useState<boolean>(true)

	useEffect(() => {
		const fetchContactOverview = async () => {
			setLoading(true)
			try {
				const response = await getDashboardContactOverview({ client: clientId })
				const data = response.map(ele => {
					return {
						title: toTileCase(ele._id.source),
						value: ele.count,
						key: ele._id.source,
					}
				})
				setStats(
					data.sort((a, b) => {
						if (a.title > b.title) {
							return 1
						}
						if (b.title > a.title) {
							return -1
						}
						return 0
					})
				)
				setLoading(false)
			} catch {
				setLoading(false)
			}
		}
		fetchContactOverview()
	}, [clientId])
	return (
		<Card title='Contact overview' className={style.layout}>
			<div className={style.position}>
				<Bar
					loading={loading}
					data={stats}
					xField='value'
					yField='title'
					seriesField='title'
					legend={{
						position: 'right',
					}}
					barBackground={{
						style: {
							fill: 'rgba(0,0,0,0.1)',
						},
					}}
					label={{
						position: 'middle',
						offsetX: 38,
						style: { fill: 'black ', lineWidth: 2 },
					}}
					interactions={[{ type: 'tooltip', enable: true }]}
					xAxis={{
						grid: {
							line: {
								style: {
									lineWidth: 0,
								},
							},
						},
					}}
					color={['#F54915', '#F6C029', '#64DAAB', '#6495FA', '#DD58D6', '#FCC9B9']}
				/>
			</div>
		</Card>
	)
}
ContactOverviewCard.defaultProps = {
	clientId: undefined,
}
export default ContactOverviewCard
